import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { START_TARGETED_DB_FLASH_MUTATION } from '../graphql/mutations'
import { TARGETED_DB_FLASH } from '../redux/action-types'

const useStartTargetedDbFlashMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.menuCurationTasks.targetedDbFlash,
  )

  const mutate = useCallback(
    dishTypeIds =>
      apolloService.mutate({
        mutation: START_TARGETED_DB_FLASH_MUTATION,
        variables: { dishTypeIds },
        dispatch,
        action: TARGETED_DB_FLASH,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error, data }]
}

export default useStartTargetedDbFlashMutation
